import { GET } from '@/api';

const URL = '/store-finder';

export default async ({
  latitude,
  longitude,
  type = null,
  distance = null,
  config,
  successCB,
  failCB,
}) => {
  try {
    const pathType = type ? `&type=${type}` : '';
    const pathDistance = distance ? `&distance=${distance}` : '';
    const { data } = await GET(
      `${URL}?latitude=${latitude}&longitude=${longitude}${pathType}${pathDistance}`,
      config,
    );
    return (typeof successCB === 'function' && successCB(data)) || data;
  } catch (e) {
    return (typeof failCB === 'function' && failCB(e)) || e;
  }
};
